import Block from "base/Block";
import Registration from "base/Registration";

class PageMenu extends Block {
	static get blockName() {
		return 'b-page-menu';
	}

	onInit() {
		this.menu = this.el.querySelector('.' + this.blockName + '__wrapper');
		this.navContainer = this.el.querySelector('.' + this.blockName + '__bottom');

		this.fixPageMenu();
		this.getNavigationView();
		this.clickNavButton();
	}

	fixPageMenu() {
		let header = document.querySelector('.header');
		let headerHeight = header.offsetHeight;
		let menuTop = this.el.offsetTop;
		let menuOffset = window.innerWidth < 430 ? 12 : 24;
		let ticking = false;
		let scroll = 0;

		if (window.pageYOffset > menuTop - headerHeight - menuOffset) {
			this.menu.classList.add('js-fixed');
			this.menu.style.top = headerHeight + menuOffset + 'px';
		}

		window.addEventListener("scroll", () => {
			let lastKnownScrollPosition = window.scrollY;
			headerHeight = header.offsetHeight;

			if (lastKnownScrollPosition > menuTop - headerHeight - menuOffset) {
				if (!ticking) {
					ticking = true;
					this.menu.classList.add('js-fixed');
				}

				if ((lastKnownScrollPosition > scroll) && (lastKnownScrollPosition > 200)) {
					this.menu.style.top = menuOffset + 'px';
				} else {
					this.menu.style.top = headerHeight + menuOffset + 'px';
				}
			} else {
				ticking = false;
				this.menu.classList.remove('js-fixed');
				this.menu.style.top = 0;
			}

			scroll = lastKnownScrollPosition;
		});

		new ResizeObserver(() => {
			this.menu.style.top = header.offsetHeight + menuOffset + 'px';
			let appLink = header.querySelector('.app-link');

			if ((window.scrollY == 0 && !appLink) || window.scrollY == 0 && window.getComputedStyle(appLink).display == 'none') {
				if (this.menu.classList.contains('js-fixed')) {
					this.menu.classList.remove('js-fixed');
				}

				this.menu.style.top = 0;
			}
		}).observe(header);
	}

	getNavigationView() {
		let navigationView = document.querySelector('.b-page-menu-nav');

		if (navigationView) {
			this.navContainer.append(navigationView);

			let itemLinks = navigationView.querySelectorAll('.b-page-menu-nav__item-link');
			itemLinks.forEach(itemLink => {
				let blockViewId = (itemLink.getAttribute('href')).slice(1);
				let blockView = document.getElementById(blockViewId);

				if (blockView) {
					let blocksViewH3 = blockView.querySelectorAll('h3');

					if (blocksViewH3.length > 0) {
						let subItemsHtml = '<ul class="b-page-menu-nav__subitems">';
						let i = 1;

						blocksViewH3.forEach(blockViewH3 => {
							blockViewH3.id = blockViewId + '-' + i;

							subItemsHtml += '<li class="b-page-menu-nav__subitem"><a href="#' +
										blockViewH3.id +'">' + blockViewH3.innerHTML +
										'</a></li>';
							i++;
						});

						subItemsHtml += '</ul>';
						itemLink.parentElement.parentElement.classList.add('b-page-menu-nav__item--parent');
						itemLink.insertAdjacentHTML('afterend', '<div class="b-page-menu-nav__item-arrow"></div>');
						itemLink.parentElement.insertAdjacentHTML('afterend', subItemsHtml);
					}
				}
			});

			navigationView.removeAttribute('data-initialized');
			Registration.blocksInit(navigationView.parentElement);
		} else {
			this.el.classList.add(this.blockName + '--without-navigation');
		}
	}

	clickNavButton() {
		let navButton = this.el.querySelector('.' + this.blockName + '__button--navigation');
		this.navContainer.style.maxHeight = 0;
		const paddingTop = 24;

		navButton.addEventListener('click', () => {
			if (this.el.classList.contains('open')) {
				this.el.classList.remove('open');
				this.navContainer.style.maxHeight = 0;
			} else {
				this.el.classList.add('open');
				this.navContainer.style.maxHeight = paddingTop + +this.navContainer.scrollHeight + 'px';
			}
		});

		let navBg = this.el.querySelector('.' + this.blockName + '__navigation-bg');
		navBg.addEventListener('click', () => {
			this.el.classList.remove('open');
			this.navContainer.style.maxHeight = 0;
		});
	}
}

Block.register(PageMenu);

export default PageMenu;
